import { ProductUploadType } from './enums';

export enum LenderCapitalRestPeriod {
  Daily = 1,
  Monthly = 2,
  Annual = 3,
}

export interface Lender {
  id: number;
  lenderNameId: number;
  lenderText: string;
  isPackager: boolean;
  lenderNotes: string;
  flowType: string | undefined;
  lenderUrl: string;
  lenderLogoUrl: string;
  affordabilityCalculatorUrl: string;
  lendersAffordabilityCalculatorUrl: string;
  lenderDetailsUrl: string;
  affordabilityCalculatorOn: boolean;
  criteriaEnabled: boolean;
  productsEnabled?: boolean;
  archived: boolean;
  source: number;
  isRestricted?: boolean;
  networksWithArchivedRestrictions?: string[];
  lenderHostedCalculatorOn?: boolean;
  hostedAsantoUrl?: string;
  capitalRestPeriod?: LenderCapitalRestPeriod;
  screenscrapeAffordabilityCalculatorUrl?: string;
}

export enum LenderProductHandlerType {
  Automatic = 0,
  Standard = 1,
  Bespoke = 2,
  Api = 3,
}

export enum ProductsVisibilityDisabledReason {
  None = 0,
  LenderRequest = 1,
  LenderInaccuracy = 2,
  LenderUnresponsive = 3,
  NotOnboarded = 4,
}

export enum AffordabilityOffReason {
  NotOnboarded = 1,
  SwitchedOffForRemapping = 2,
  SwitchedOffLenderIssues = 3,
  ComingSoonOnlyWhenInBuild = 4,
  NoLongerLending = 5,
}

export interface LendersAbilityResponse {
  affordabilityLenders: string[];
  productLenders: string[];
}
export interface LenderNameLender {
  lendingTypeId: number;
  lenderId: number;
  productsVisibilityEnabled?: boolean;
}
export interface LenderName {
  lenderNameId: number;
  lenderName: string;
  lenderLogoUrl: string;
  lenderDetailsUrl: string;
  lenders: LenderNameLender[];
  name: string;

  // Additional lender properties
  hasProducts: boolean;
  hasLiveProducts: boolean;
  hasSchedule: boolean;
  separateExclusiveUpload: boolean;
  resiBtlProductHandlerType: LenderProductHandlerType;
}

export interface ProcFeeLender {
  id: number;
  lender: string;
  mortgageAccountNumberFormatPattern: string;
  mortgageAccountNumberFormatDescription: string;
}

export interface LenderOptions {
  outcomeId: number;
  outcomeResult: string;
  id: number;
  parentId?: number;
  questionText: string;
  questionDescription: string;
  hierarchyId: number;
  flowType: string;
}

export interface ProcFeeClaimFormProductViewModel {
  productDescription: string;
  lenderCode: string;
  fromDate: string;
  toDate: string;
}

export enum TrackerProductRateType {
  BankOfEngland = 1,
  CustomLenderRate = 2,
}

export interface LenderProductsConfig {
  hasProducts: boolean;
  showProducts: boolean;
  showTrueCost: boolean;
  resiBtlLenderProductHandlerType: LenderProductHandlerType;
  resiBtlProductHandlerUrl?: string | null;
  resiBtlExclusiveProductHandlerType: LenderProductHandlerType | null;
  separateExclusiveUpload: boolean;
  productsVisibilityDisabledReason?: ProductsVisibilityDisabledReason;
  productsVisibilityEnabled: boolean;
  trackerProductRateType: TrackerProductRateType;
}

export interface LenderProductsConfigWithValidation extends LenderProductsConfig {
  validationErrors: string[];
}

export interface OtherLenderType {
  id: number;
  lenderNameId: number;
  flowType: string;
}

export interface LendingTypeViewModel {
  lenderId: number;
  lendingTypeId: number;
  active: boolean;
}

export interface LenderManagementViewModel {
  lenderNameId: number;
  lenderText: string;
  internalLenderCode: string;
  externalLenderCode: string;
  lenderNameVariations: string[];
  lendingTypes: LendingTypeViewModel[];
  onBoarded: boolean;
  packager: boolean;
  archived: boolean;
  lendersGroupId: number | undefined;
  fairValueDocuments: FairValueDocument[];
}

export interface LenderLendingType {
  lenderId: number | undefined;
  lendingTypeId: number;
  name: string;
  checked: boolean;
}

export interface ProductUpload {
  id: number;
  uploadDate: string;
  scheduleDate: string;
  isImmediate: boolean;
  withdrawalVisibility: boolean;
  uploadType: ProductUploadType;
  uploadedBy: string | null;
  successful: boolean;
  errors: string | null;
  canDownload: boolean;
}

export interface LenderDocument {
  lenderName: string;
  lenderNameId: number;
  fairValueDocuments: FairValueDocument[];
}

export interface FairValueDocument {
  id?: number;
  urlLink: string;
  description: string;
  updatedDate?: string;
}
